import { IComponentOptions } from "angular";
import { MachineTypeIdInfoComponentController } from "./controller";

export const vsComponentName = "machineTypeIdInfoComponent";

export const machineTypeIdInfoComponentOptions: IComponentOptions = {
  controller: MachineTypeIdInfoComponentController,
  controllerAs: "machineTypeIdInfoComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    typeId: "<",
    progressiveCalculatedFields: "<?",
  },
};
